import React from 'react';

function Home() {
  return (
    <div style={
      {
        fontFamily: 'Poppins, sans-serif'
      }
    } className=" bg-black text-white ">
      
      
      <main className=" ">
     
        <div className="text-center relative ">
          
        <div style={{
           backgroundImage: "url('/landingpage2.webp')"
        }} className=' w-full bg-cover flex flex-col items-center bg-slate-800'>
          <img src='/BandlandLogo.png' alt='Bandland Logo' className='mt-[10px] md:mt-[30px] w-[27%]' />
           <img src='/lineup-new 1.png' alt='Presale' className=' bg-black  w-[250px] md:w-[60%] lg:w-[60%]' />
             <img src='/planet 03.png' alt='Planet 3' className='absolute right-[14%] hidden md:block top-[20%] w-[33px] md:w-[80px]' />
               <img src='/planet 02.png' alt='Planet 2' className='absolute left-[9%] hidden md:block md:left-[10%] top-[38%] md:top-[34%] w-[70px] md:w-[150px]' />
                 <img src='/planet 01.png' alt='Planet 1' className='absolute right-[15%] hidden md:block bottom-[23%] md:bottom-[25%] w-[60px] md:w-[200px]' />
           <button onClick={() => {
            window.location.href = 'https://in.bookmyshow.com/events/bandland-2026/ET00466059';
           }} className='bg-red-500 mt-[10px] md:mt-[20px] md:mb-[20px] font-bold text-[8px] md:text-[14px] text-white rounded-[2px] px-[8px] py-[4px] md:px-[16px] md:py-[8px]'>
            BOOK NOW
           </button>
            <img src='/COME HOME TO BANDLAND.png' alt='Come Home to Bandland' className='mt-[10px] bottom-[30%] bg-black md:mt-[30px] w-[140px] absolute md:relativve  md:w-[350px] lg:w-[400px]' />
             <img src='/Group 29 (1).png' alt='Event Details' className='mb-[15px] md:mb-[0px]   w-[88%]' />
            {/* <img src='/footer (2).png' alt='Footer' className='w-full absolute h-auto bottom-[-33%] md:bottom-[-35%]' /> */}
        </div>
         
        </div>
      

      </main>
    </div>
  );
}

export default Home;